module.exports = __webpack_public_path__ + "img/user-slash.038ae2c1.svg";